<template>
  <component :is="view" :class="{ 'weui-cell': true, 'weui-cell_access': link }" v-bind="props" @click="$emit('click')">
    <div v-if="label" class="weui-cell__hd">
      <label class="weui-label">{{ label }}</label>
    </div>
    <div class="weui-cell__bd">
      <slot>{{ text }}</slot>
    </div>
    <div class="weui-cell__ft">
      <slot name="tips">{{ tips }}</slot>
    </div>
  </component>
</template>

<script>
export default {
    name: 'Cell',
    props: {
        link: {
            type: [Object, String, Boolean],
            default: null,
        },
        label: {
            type: String,
            default: null,
        },
        text: {
            type: String,
            default: null,
        },
        tips: {
            type: String,
            default: null,
        },
    },
    computed: {
        view() {
            if (this.link) {
                if (typeof this.link === 'object') {
                    return 'router-link';
                }
                return 'a';
            }
            return 'div';
        },
        props() {
            if (this.link) {
                if (typeof this.link === 'object') {
                    return {
                        to: this.link,
                    };
                }
                if (this.link !== true) {
                    return {
                        href: this.link,
                    };
                }
            }

            return {};
        },
    },
};
</script>

<style lang="scss">
.weui-cell {
    min-height: 6vw;
}
</style>



// WEBPACK FOOTER //
// src/components/weui/cell/Index.vue